import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { setHasNoData } from "../Directory/directorySlice";

export const fetchRuleFieldData = createAsyncThunk(
  "ruleFields/fetchRuleFieldData",
  async ({ url, config }, { dispatch }) => {
    const response = await axios.get(url, config);
    const data = response.data.data;

    if (!data || data.length === 0) {
      dispatch(setHasNoData(true));
    } else {
      dispatch(setHasNoData(false));
    }
    return data;
  }
);

const initialState = {
  ruleFields: [],
  status: "idle",
  loading: true,
  error: null,
};

const ruleFieldSlice = createSlice({
  name: "ruleFields",
  initialState,
  reducers: {
    addRuleField: (state, action) => {
      state.ruleFields.push(action.payload);
    },

    updateRuleField: (state, action) => {
      const { id, updatedData } = action.payload;
      const index = state.ruleFields.findIndex((field) => field.id === id);
      if (index !== -1) {
        state.ruleFields[index] = { ...updatedData };
      }
    },

    deleteRuleField: (state, action) => {
      const id = action.payload;
      state.ruleFields = state.ruleFields.filter((field) => field.id !== id);
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchRuleFieldData.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchRuleFieldData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.ruleFields = action.payload;
        state.loading = false;
      })
      .addCase(fetchRuleFieldData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { addRuleField, updateRuleField, deleteRuleField } = ruleFieldSlice.actions;

export default ruleFieldSlice.reducer;
